import React, { useState, useEffect, useRef } from "react";

function EnglishView() {

  const didRun = useRef(false);
  
  useEffect(() => {
    if (!didRun.current) {
      const link = document.createElement("a");
      link.href = '/media/eng_cv_jgu.pdf'; // URL del documento
      link.download = "cv_eng_jesus_gomez.pdf"; // Nombre con el que se guardará
      link.target = "_blank"; // Opcional: abre en otra pestaña
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      didRun.current = true;
    }
  }, [])



  return (
    <>
     <iframe src="/media/eng_cv_jgu.pdf" width="100%" height="600px" style={{ border: "none"}}></iframe>
    </>
  );
}

export default EnglishView;
